export const ALGOLIA_STORAGE_KEY = "algolia.storage";
export const ALGOLIA_PARAM_QUERY = "aa_query";
export const ALGOLIA_PARAM_SKU = "aa_sku";
export const ALGOLIA_PARAM_INDEX = "aa_index";

type AlgoliaStorage = {
  products: Record<string, { queryId: string; index: string }>;
};

export function getAlgoliaStorage() {
  let value = JSON.parse(
    localStorage.getItem(ALGOLIA_STORAGE_KEY)
  ) as AlgoliaStorage;
  if (!value || !("products" in value)) {
    value = {
      products: {},
    };
  }
  return value;
}

function setAlgoliaStorage(value: AlgoliaStorage) {
  localStorage.setItem(ALGOLIA_STORAGE_KEY, JSON.stringify(value));
}

export function pushProductQueryId(
  productSku: string,
  queryId: string,
  index: string
) {
  const value = getAlgoliaStorage();
  value.products[productSku] = { queryId, index };
  setAlgoliaStorage(value);
}
